import { useEffect, useState } from "react";

export default function useSearchQuery() {
  const [query, setQuery] = useState("");
  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (input: string) => {
    setInputValue(input);
  };

  useEffect(() => {
    if (inputValue.length >= 0 && inputValue.length < 2) return;
    const delayDebounceFn = setTimeout(() => {
      setQuery(inputValue);
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [inputValue, setInputValue]);

  return { query, handleInputChange };
}
